define((require) => {
    "use strict";

    const _                                = require("underscore");
    const $                                = require("jquery");
    const Enum                             = require("shared/util/Enum");
    const FontsDotComIntegrationModel      = require("editor/ui/settings/integrations/FontsDotComIntegrationModel");
    const CustomFontIntegrationModel       = require("editor/ui/settings/integrations/CustomFontIntegrationModel");
    const ManageFontsDotComIntegrationView = require("editor/ui/settings/fonts/ManageFontsDotComIntegrationView");
    const ManageTypekitIntegrationView     = require("editor/ui/settings/fonts/ManageTypekitIntegrationView");
    const ManageCustomFontsIntegrationView = require("editor/ui/settings/fonts/ManageCustomFontsIntegrationView");
    const Marionette                       = require("marionette");
    const SettingsView                     = require("ui/settings/SettingsView");
    const template                         = require("editor/ui/settings/fonts/ManageFontsIntegrationView.tpl");
    const TypekitIntegrationModel          = require("editor/ui/settings/integrations/TypekitIntegrationModel");

    // TODO MOS-2555: Add proper tab support to the SettingsView or introduce a concrete "TabbedView".

    const Tab = function(name, slug, integration, viewClass, sortOrder) {
        this.name = name;
        this.slug = slug;
        this.integration = integration;
        this.viewClass = viewClass;
        this.sortOrder = sortOrder;
        this.active = false;
    };

    const Tabs = Enum.create("Tab", {

        CUSTOM_FONTS: new Tab("Custom", "custom-fonts", CustomFontIntegrationModel, ManageCustomFontsIntegrationView, 1),

        TYPEKIT: new Tab("Typekit", "typekit", TypekitIntegrationModel, ManageTypekitIntegrationView, 2),

        FONTS_DOT_COM: new Tab("Fonts.com", "fonts-dot-com", FontsDotComIntegrationModel, ManageFontsDotComIntegrationView, 3)

    }, {
        fromIntegration(integrationConstructor) {
            return this.each((tab) => {
                if (tab.integration === integrationConstructor) {
                    return tab;
                }
            });
        }
    });

    /**
     * Manages font integrations configurations.
     *
     * @class ManageFontsIntegrationView
     */
    return SettingsView.extend("ManageFontsIntegrationView", {

        className: SettingsView.prototype.className + " fonts-view",

        template,

        ui: {
            tabs: ".tab",
            integrationsContainer: ".integrations-container"
        },

        regions() {
            return _.extend(SettingsView.prototype.regions, {
                integrationsRegion: ".integrations-region"
            });
        },

        _tabs: null,

        _regions: null,

        _children: null,

        initialize() {
            this._tabs = this._createTabs();
        },

        onRender() {
            this._regions = [];
            this._children = [];

            this._tabs.forEach((tab) => {
                const $regionElement = $("<div></div>")
                    .prependTo(this.ui.integrationsContainer);

                const region = new Marionette.Region({el: $regionElement});
                const View = tab.viewClass;
                const model = this._getIntegrationModel(tab.integration);

                const view = new View({model: model});
                view.$el.addClass(tab.slug);

                view.active(tab.active);

                this.listenTo(view, "change", this._viewChangeHandler);

                region.show(view);

                this._regions.push(region);
                this._children.push(view);
            });
        },

        events: {
            "click @ui.tabs": "_tabSelectionHandler"
        },

        templateHelpers() {
            return {
                tabs: this._tabs
            };
        },

        _createTabs() {
            const integrations = this.options.integrations.slice(0);

            const tabs = integrations
                .map((fontIntegration) => {
                    return Tabs.fromIntegration(fontIntegration.constructor);
                })
                .sort((a, b) => {
                    return a.sortOrder > b.sortOrder;
                });

            tabs[0].active = true;

            return tabs;
        },

        _getIntegrationModel(integrationClass) {
            return _.find(this.options.integrations, (integrationModel) => {
                return integrationModel instanceof integrationClass;
            });
        },

        _viewChangeHandler($el, value, view) {
            this.trigger("validated", view.model);
        },

        /**
         * @private
         *
         * Handles tab clicks and calls to select the tab.
         *
         * @param {Event} event The click event
         */
        _tabSelectionHandler(event) {
            this.ui.tabs.removeClass("active");

            const $tabElement = $(event.currentTarget);
            const slug = $tabElement.attr("data-tab");

            $tabElement.addClass("active");

            this._children.forEach((view) => {
                view.active(view.$el.hasClass(slug));
            });
        },

        onClose() {
            this.__super();

            _.invoke(this._regions, "close");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/fonts/ManageFontsIntegrationView.js